import { showNotification } from '@helpers/notification-helper';
import useDeleteSoftwareMerchant from '@hooks/query/software-provider/useDeleteSoftwareMerchant';
import { Modal } from '@ui';
import React from 'react';
import { TMyProvider } from 'types/software-provider.types';

interface DeleteMerchantModalProps {
  item?: TMyProvider;
  visible: boolean;
  onClose: () => void;
  afterSubmit?: () => void;
}

const DeleteMerchantModal: React.FunctionComponent<DeleteMerchantModalProps> = ({
  onClose,
  visible,
  item,
  afterSubmit,
}) => {
  const { mutate, isLoading } = useDeleteSoftwareMerchant({
    onSuccess: () => {
      showNotification({ type: 'SUCCESS', title: 'Napojenie odstránené', copy: '' });
      onClose();
      afterSubmit?.();
    },
    onError: () => {
      showNotification({ type: 'ERROR', title: 'Niečo sa pokazilo', copy: '' });
    },
  });

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      title="Zmazať napojenie"
      footer={
        <Modal.Actions
          actions={[
            { key: 'cancel', label: 'zrušiť', variant: 'ghost', onClick: onClose },
            {
              key: 'submit',
              label: 'Odstrániť',
              variant: 'danger',
              onClick: () => {
                if (item) {
                  mutate(item.requestId);
                }
              },
              loading: isLoading,
            },
          ]}
        />
      }
    >
      <Modal.Title>Naozaj chcete zmazať napojenie?</Modal.Title>
      <Modal.Description>
        Zmazaním napojenia <strong>{item?.name ?? '-'}</strong> so službou{' '}
        <strong>{item?.merchant.name ?? '-'}</strong> môžte prísť o dáta a funkcionality, ktoré dané
        napojenie poskytuje.
      </Modal.Description>
    </Modal>
  );
};

export default DeleteMerchantModal;
